import {
  liveStatsVuexGetters,
} from '@ahaslides-product/frontend-toolkit'
import config from '@/config'
import { isFeatureEnabled, isPresentationCreatedAfterTurnOnFlag, isPresentationResetAfterTurnOnFlag } from '../feature-toggles.module'

const isLiveProxyNotEnabledOnLocal = config.env === 'local' && !config.isLiveProxyUrlSet

const _getters = {
  ...liveStatsVuexGetters,
  canUseKvSyncLiveStats: (_, __, rootState, rootGetters) => {
    return (isPresentationCreatedAfterTurnOnFlag(rootGetters, 'kv-sync-emqx-for-live-stats') || isPresentationResetAfterTurnOnFlag(rootState.presentation, 'kv-sync-emqx-for-live-stats')) &&
      isFeatureEnabled(rootGetters, 'kv-sync-emqx-for-live-stats')
  },
  canSubmitReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canSubscribeReactionEmqx: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseLiveStatsForQuizV2: (_, __, ___, rootGetters) => {
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'livestats-quiz-submission-v2')
  },
  canUseLiveStatsForQuiz: (_, __, ___, rootGetters) => {
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'livestats-quiz-submission')
  },
  canUsePollLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-poll')
  },
  canRetireLiveApi: (_, getters, ___, rootGetters) => {
    return getters.canUseLiveStatsForQuizV2 && isFeatureEnabled(rootGetters, 'retire-live-api')
  },
  canUsePollLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseScaleLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseWordCloudLiveApi: (_, getters) => {
    return getters.canUseKvSyncLiveStats
  },
  canUseWordCloudLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-wordcloud')
  },
  canUseScaleLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-scale')
  },
  canUseReactionLiveProxy: (_, getters, ___, rootGetters) => {
    if (!getters.canUseKvSyncLiveStats) return false
    if (isLiveProxyNotEnabledOnLocal) {
      return false
    }
    return isFeatureEnabled(rootGetters, 'liveproxy-submit-reaction')
  },
  liveStatsVersionPrefix: () => {
    return config.newKafkaClusterPrefix || 'ST2'
  },
  canAddDeltaForAhaSync: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'AHA-37132-get-with-delta')
  },
}

export default _getters
